export default "__VITE_ASSET__CyOENZs0__"